import { useRef, useEffect, useState } from 'react';
import styles from './index.module.less';
import setDefaultImg from '@/assets/img/set-default.png';
import highLightImg from '@/assets/img/high-light.png';
import { ifHaveView, ifInView, ifOutView, report, getQueryVariable } from '@/utils';

const buttonSetClick = '1';
const buttonUnsetClick = '2';
const shortcutDefaultTabId = 117;
const source = getQueryVariable('source');

const exitWebview = () => {
  if (window.browser) {
    switch (window.browser.env?.platForm) {
      case 'ADR':
        window.browser.qbmarket?.historyBack();
        break;
      case 'I':
      case 'iPad':
        window.browser.app?.historyBack();
        break;
    }
  }
};

const SetDefaultPage = ({ describeText, id, titleList }) => {
  const setDefaultTitle = useRef(null);
  const lastPageEleStart = useRef(null);
  const lastPageEleEnd = useRef(null);
  const lastPageScrollEvent = useRef(null);

  const [lastPageAnima, setLastPageAnima] = useState(false);
  const [titleAnima, setTitleAnima] = useState(false);

  //
  useEffect(() => {
    //
    window.removeEventListener('scroll', lastPageScrollEvent.current);
    if (lastPageAnima) {
      lastPageScrollEvent.current = () => {
        if (ifOutView(lastPageEleStart.current)) {
          setTitleAnima(false);
          setLastPageAnima(false);
        }
      };
    } else {
      lastPageScrollEvent.current = () => {
        if (ifInView(setDefaultTitle.current)) {
          setTitleAnima(true);
        }
        if (ifHaveView(lastPageEleEnd.current)) {
          report({
            action: 'h5_box_exp',
            source,
            task_id: getQueryVariable('taskId'),
          });
          setLastPageAnima(true);
        }
      };
    }

    window.addEventListener('scroll', lastPageScrollEvent.current);
    return () => {
      window.removeEventListener('scroll', lastPageScrollEvent.current);
    };
  }, [lastPageAnima]);

  const setDefaultPage = () => {
    report({
      action: 'h5_box_clk',
      button_clk: buttonSetClick,
      source,
      task_id: getQueryVariable('taskId'),
    });
    window.browser?.qb?.setDefaultHomeTab?.(
      {
        tabId: shortcutDefaultTabId,
      },
      (res) => {
        if (res) {
          window.browser?.app?.toast?.(res ? '设置成功，欢迎体验' : '设置失败，请重试', 0);
          setTimeout(() => {
            exitWebview();
          }, 1700);
        }
      },
    );
  };

  const noSetDefault = () => {
    report({
      action: 'h5_box_clk',
      button_clk: buttonUnsetClick,
      source,
      task_id: getQueryVariable('taskId'),
    });
    exitWebview();
  };

  return (
    <div className={`${styles.block} ${styles['set-default-block']}`} id={id}>
      <div ref={lastPageEleStart}></div>
      <div className={`${styles.title} ${titleAnima ? styles.transMoveUp : ''}`} ref={setDefaultTitle}>
        {describeText.map((v, i) => (
          <div
            key={i}
            dangerouslySetInnerHTML={{
              __html: v,
            }}
          ></div>
        ))}
      </div>
      <div className={styles['content-wrapper']}>
        <div className={`${styles.content} ${lastPageAnima ? styles['content-anima'] : ''}`}>
          <div className={styles.img}>
            <img width="100%" src={setDefaultImg} />
          </div>
          <div className={styles.text1}>{titleList[0]}</div>
          <div ref={lastPageEleEnd}></div>
          <div className={styles.text2}>{titleList[1]}</div>
          <div
            className={`${styles['set-button']} ${lastPageAnima ? styles['set-button-anima'] : ''}`}
            onClick={setDefaultPage}
          >
            立刻设置
            <div className={styles['hight-light1']}>
              <img height="100%" src={highLightImg} />
            </div>
            <div className={styles['hight-light2']}>
              <img height="100%" src={highLightImg} />
            </div>
          </div>
          <div className={styles['not-set-button']} onClick={noSetDefault}>
            暂不设置
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetDefaultPage;
